// components
import { ControlledCheckbox } from 'components/shared/ControlledFields';

// types
import { ControlledCheckboxProps } from 'components/shared/ControlledFields/ControlledCheckbox';

export const ControlledCheckboxCompact = (props: ControlledCheckboxProps) => (
  <ControlledCheckbox {...props} sx={{ height: 32, ...props.sx }} />
);
